import {
  BOOKADD,
  BOOKDELETE,
  BOOKEDIT,
  BOOKLOADED,
  BOOKUPDATE
} from "./actionTypes";

// BOOK LIST LOAD
export const bookLoaded = (books, filterStatus) => {
  return {
    type: BOOKLOADED,
    payload: {books, filterStatus},
  };
};

// NEW BOOK ADD
export const bookAdd = (book) => {
  return {
    type: BOOKADD,
    payload: book,
  };
};

// SPECIFIC BOOK EDIT
export const bookEdit = (book) => {
  return {
    type: BOOKEDIT,
    payload: book,
  };
};

// SPECIFIC BOOK EDIT
export const bookUpdate = (updatedBook, featuredStatus) => {
  return {
    type: BOOKUPDATE,
    payload: {updatedBook, featuredStatus},
  };
};

// SPECIFIC BOOK DELETE
export const bookDelete = (bookId) => {
  return {
    type: BOOKDELETE,
    payload: bookId,
  };
};
